import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CargaDescargaCajaRutaDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Caja", cell: x => ({ data: x.NombreCaja }) },
    { title: "Tipo", cell: x => ({ data: models.TipoCargaDescarga[x.Tipo] }) },
    { title: "Status", cell: x => ({ data: models.StatusCargaDescarga[x.Status] }) },
    { title: "Fecha de inicio", cell: x => ({ data: kea.toDate(x.FechaInicio) }) },
    { title: "Fecha terminó", cell: x => ({ data: kea.toDate(x.FechaTermino) }) },
    { title: "Cant. de guias", cell: x => ({ data: x.CantidadGuias }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Ruta", cell: x => ({ data: x.NombreRuta }) },
    { title: "Camión asignado", cell: x => ({ data: x.NombreCamionAsignado }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChofer }) },
    { title: "Tiene paquetes/sobres", cell: x => ({ data: x.TieneServiciosArriba }) },
    { title: "Tiene guas incompletas", cell: x => ({ data: x.TieneGuiasIncompletas }) },
    { title: "Folio", cell: x => ({ data: x.Folio }) },
];

export interface BotonesDeps {
    onCancelar: (x: Entity) => void;
    onVer: (x: Entity) => void;
    onReabrir: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): Column[] {
    const botones = kea.columnaBotones([
        {
            iconClass: fa("eye"),
            onClick: deps.onVer,
            tooltip: "Ver",
            style: "info"
        }, {
            iconClass: fa("times"),
            onClick: deps.onCancelar,
            tooltip: "Cancelar",
            style: "danger"
        }, {
            iconClass: fa("refresh"),
            onClick: deps.onReabrir,
            tooltip: "Reabrir proceso",
            style: "success"
        }
    ]);
    return [botones, ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cargasdescargas/columnas.tsx